
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class HSNGrid extends Serenity.EntityGrid<HSNRow, any> {
        protected getColumnsKey() { return 'OMS.HSN'; }
        protected getDialogType() { return HSNDialog; }
        protected getIdProperty() { return HSNRow.idProperty; }
        protected getInsertPermission() { return HSNRow.insertPermission; }
        protected getLocalTextPrefix() { return HSNRow.localTextPrefix; }
        protected getService() { return HSNService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}